import { voidFunction } from '@avantia/client-and-server-utilities';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../config/configuration';
import { ExternalLink } from '../engineClient/components/formControls/common/externalLink';
import { HpViewportState } from '../engineClient/types';
import { HpGlobalState } from '../types/stateTypes';
import './footer.scss';
import { PreloadData } from './preloadData';

const { releaseVersion } = getConfig();

function FooterComponent({ version, viewport }: FooterProps): JSX.Element {
  const { isDesktop } = viewport;
  const desktopSpacer = <>&nbsp;&nbsp;&bull;&nbsp;&nbsp;</>;
  const spacer = !isDesktop ? <br /> : desktopSpacer;
  const linksSpacer = desktopSpacer;
  const compositeVersion = releaseVersion + (version ? `/${version}` : '');

  return (
    <footer className="container hp-footer hp-center">
      <Row>
        <Col xs={12} className="footer-text">
          <p>
            Homeprotect is a registered trademark and trading style of Avantia Insurance Limited which is authorised and
            regulated by the Financial Conduct Authority with registered number 304432. AXA Insurance is the lead
            underwriter for Home Insurance. AXA Insurance UK plc is authorised by the Prudential Regulation Authority
            and regulated by the Financial Conduct Authority and the Prudential Regulation Authority with registered
            number 202312. Registered address is 20 Gracechurch Street, London, EC3V 0BG. Registered in England and
            Wales registered number 078950.
          </p>
          <p>
            Copyright &copy; Avantia Insurance Ltd {new Date().getFullYear()}
            {spacer}
            <ExternalLink id="avantia-group-footer-link" href="https://www.avantiagroup.co.uk" />
            {spacer}
            {compositeVersion}
          </p>
          <ul className="hp-footer-links">
            {[
              { id: 'legal', text: 'Legal', url: 'legal-terms-of-use' },
              { id: 'privacy', text: 'Privacy policy', url: 'security-privacy' },
              { id: 'cookie-policy', text: 'Cookie policy', url: 'cookie-policy' }
            ].map(({ id, text, url }, ix) => {
              return (
                <li key={text}>
                  {ix > 0 ? linksSpacer : null}
                  <ExternalLink id={`${id}-footer-link`} href={`https://www.homeprotect.co.uk/${url}`}>
                    {text}
                  </ExternalLink>
                </li>
              );
            })}
            <li key="manage-privacy-settings">
              {linksSpacer}
              <a
                href="/"
                id="change-cookie-prefs-link"
                onClick={(ev) => {
                  ev.stopPropagation();
                  ev.preventDefault();
                  const handler = (window as any).__tcfapi;
                  if (handler) {
                    handler('displayConsentUi', 2, voidFunction);
                  }
                }}
                tabIndex={0}
              >
                Manage Privacy Settings
              </a>
            </li>
          </ul>
        </Col>
      </Row>
      <PreloadData />
    </footer>
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: HpGlobalState): FooterProps => {
  const { questionSet, userInterface } = state;
  const { version } = questionSet;
  const { viewport } = userInterface;
  return { version, viewport };
};

const mapDispatchToProps = {};

interface FooterProps {
  version: string;
  viewport: HpViewportState;
}

const Footer = withRouter(connect(mapStateToProps, mapDispatchToProps)(FooterComponent) as any);

export { Footer };
